document.addEventListener('alpine:init', () => {
    window.Alpine.magic('toChf', () => (value) => {
        const floatValue = parseFloat(value);

        if (isNaN(floatValue) || floatValue === 0) {
            return '';
        }

        // Round the value up to the nearest 0.01
        const roundedValue = Math.ceil(floatValue * 100) / 100;

        // Split into integer and decimal parts
        const [intPart, decimalPart] = roundedValue.toFixed(2).split('.');

        // Format the integer part with thousands separators
        const formattedIntPart = parseInt(intPart, 10) === 0 ? '–' : parseInt(intPart, 10).toLocaleString('de-CH').replace(/,/g, '\'');

        // Handle the decimal part
        const formattedDecimalPart = decimalPart === '00' ? '–' : decimalPart;

        // Combine and return the formatted value
        return `CHF ${formattedIntPart}.${formattedDecimalPart}`;
    });
});
